import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Team, User, Workspace } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0210. チーム詳細
 * [GET] /workspaces/:identifier/teams/:id
 */
type Props = {
  identifier: string;
  id: number;
};
const team = (props: Props): Promise<Team> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.id}`);
};

export const useTeam = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.id],
    queryFn: () => team(props),
  });
};

export const useTeamInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', props.identifier, 'teams', props.id] });
  };

  return { invalidate };
};
